import React from 'react';
import Loadable from 'react-loadable';

const LoadableWidget = Loadable({
  loader: () => import(/* webpackChunkName: "SportsEventPageWidget" */ './SportsEventPageWidget'),
  modules: ['./SportsEventPageWidget'],
  loading: () => <div />
});

export default LoadableWidget;
